export default __webpack_public_path__ + "static/media/jit-pay-logo.9a27934f.svg";